/*
 | -------------------------------------------------------------
 |  --> type: section
 |  --> name: high contrast
 | -------------------------------------------------------------
 |
 |  Set the session storage for the user preference to either
 |  use normal contrast (default) or high contrast.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
*/

let contrastMode = window.localStorage.getItem('contrastMode')
const contrastModeToggle = document.querySelector('#contrast-toggle')
const contrastModeIcon = contrastModeToggle.querySelector('.fa-adjust')

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

/**
 * Enable contrast mode on toggle and set storage item to true
 */
const enableConstrastMode = () => {
  document.body.classList.toggle('normal-contrast')
  window.localStorage.setItem('contrastMode', 'true')
}

/**
 * Disable contrast mode on toggle and set storage item to true
 */
const disableConstrastMode = () => {
  document.body.classList.toggle('normal-contrast')
  window.localStorage.setItem('contrastMode', null)
}

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

if (contrastMode === 'true') {
  enableConstrastMode()
}

// add event listener to contrast toggle button if it exists
contrastModeToggle && contrastModeToggle.addEventListener('click', () => {
  // set storage item for the session of the user
  contrastMode = window.localStorage.getItem('contrastMode')
  const constrastText = contrastModeToggle.querySelector('span')

  // if else to check whether constrastMode is true or false
  if (contrastMode !== 'true') {
    enableConstrastMode()
    contrastModeToggle.setAttribute('aria-label', 'normaal contrast')
    contrastModeToggle.setAttribute('aria-pressed', 'true')
    constrastText.textContent = 'normaal contrast'
    contrastModeIcon.setAttribute('aria-label', 'normaal contrast')
  } else {
    disableConstrastMode()
    contrastModeToggle.setAttribute('aria-label', 'vergroot contrast')
    contrastModeToggle.setAttribute('aria-pressed', 'false')
    constrastText.textContent = 'vergroot contrast'
    contrastModeIcon.setAttribute('aria-label', 'vergroot contrast')
  }
})
